import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import ApplicationItem from "../models/ApplicationItem.tsx";
import MenuComponent from "../components/Menu.tsx";

function AdminApplications() {
  const navigate = useNavigate();
  const { authorization, SetAuthorization } = useAuth();
  const [applications, SetApplications] = useState<ApplicationItem[]>([]);

  useEffect(() => {
    if (authorization) {
      fetch("/api/applications?token=" + authorization.Token)
        .then(response => response.json())
        .then(data => SetApplications(data))
        .catch(error => console.log(error));
    }
  }, [authorization]);

  const scrollY = useRef(0);

  useEffect(() => {
    if (applications.length > 0) {
      const saved = sessionStorage.getItem("Applications");
      console.log("Saved scroll position:", saved);
      if (saved) {
        window.scrollTo(0, parseInt(saved, 10));
      }
    }
  }, [applications]);

  useEffect(() => {
    const handleScroll = () => {
      scrollY.current = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      sessionStorage.setItem("Applications", String(scrollY.current));
    };
  }, []);

  return (
    <>
      <MenuComponent page={"Applications"} />

      <section id="main">
        <div className="container">
          <div className="appList admApp">
            <article>
              <div></div>
              <div>Application #</div>
              <div>Employer</div>
              <div>Create Date</div>
              <div>Last Revised</div>
              <div>Actioned by</div>
            </article>

            {applications.map(application => (
              <article key={application.ApplicationId}>
                <div>
                  <ul>
                    <li><a onClick={() => navigate("/admin/application/" + application.ApplicationId)}><img src="/images/icon-edit.png" alt="Edit Application" title="Edit Application" /></a></li>
                    <li>
                      <span className="tooltip">
                        {application.ApplicationStatusId == 1 && <><img src="/images/Submitted.png" alt="Submitted" /><span className="tooltiptext">Submitted</span></>}
                        {application.ApplicationStatusId == 2 && <><img src="/images/Under-Review.png" alt="Under Review" /><span className="tooltiptext">Under Review</span></>}
                        {application.ApplicationStatusId == 3 && <><img src="/images/Incomplete.png" alt="Incomplete" /><span className="tooltiptext">Incomplete</span></>}
                        {application.ApplicationStatusId == 4 && <><img src="/images/Complete.png" alt="Complete" /><span className="tooltiptext">Complete</span></>}
                        {application.ApplicationStatusId == 5 && <><img src="/images/Decline-Recommend.png" alt="Declined to Recomment" /><span className="tooltiptext">Decline to Recommend</span></>}
                        {application.ApplicationStatusId == 6 && <><img src="/images/Withdrawn.png" alt="Withdrawn" /><span className="tooltiptext">Withdrawn</span></>}
                        {application.ApplicationStatusId == 7 && <><img src="/images/Ineligible.png" alt="Ineligible" /><span className="tooltiptext">Ineligible</span></>}
                        {application.ApplicationStatusId == 8 && <><img src="/images/Recommended.png" alt="Recommended" /><span className="tooltiptext">Recommended</span></>}
                      </span>
                    </li>
                  </ul>
                </div>
                <div>{application.JobNumber}</div>
                <div>{application.Employer}</div>
                <div>{Moment.tz(application.CreatedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy")}</div>
                <div>{Moment.tz(application.ModifiedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy")}</div>
                <div>{application.ModifiedBy}</div>
                <div></div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminApplications;